import { useEffect } from "react";
import { useFetch } from "../../../hooks/useFetch";
import { fetchUsers } from "../services/usersService";

export function useUsers() {
  const { data, isLoading, error, fetchData } = useFetch(fetchUsers);

  useEffect(() => {
    fetchData().catch(() => {
      // Failure is already captured in `error` state via useFetch; swallow
      // here so a rejection doesn't surface as an unhandled promise rejection.
    });
  }, [fetchData]);

  return {
    users: data ?? [],
    isLoading,
    error,
  };
}
